/*
	A common http service to handle API calls.
	Here request url, mockJSON , ErrorResponse are handle./*

	How to define mock responce?
	mock type 1 : http://stackoverflow.com/questions/40858663/how-to-get-the-data-from-local-json-to-the-html-page-using-ionic-2-typescript#answer-40859176
	mock type 2 : http://jasonwatmore.com/post/2016/11/24/angular-2-mockbackend-example-for-backendless-development
*/
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, RequestOptionsArgs, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from '../app.constant';
import { ErrorService } from './error.service';
import * as moment from 'moment';
import * as _ from 'lodash';
@Injectable()
export class HttpService {

  public response: any;
  public API_URL = Constants.Var.BASE_URL;
  public isMasterMockTrue: boolean = Constants.Var.isMasterMockTrue;
  public timerArr = [];
  public counter = 0;
  public redirectTime;
  public timeOutConfig = Constants.CurrentConfigInformations('timeOutSpecificForSomeApis');
  constructor(
    public http?: Http,
    private _err?: ErrorService,
    public router?: Router,
    public _route?: ActivatedRoute,
  ) {
    // console.log(
    //   'Base Api :' + Constants.Var.BASE_URL +
    //   ' production? ' + Constants.Var.production +
    //   ' isMasterMockTrue? ' + Constants.Var.isMasterMockTrue +
    //   ' env: ' + Constants.Var.env
    // );
  }

  protected getApi(url: string, options: RequestOptionsArgs, mockFileName: string, isMockTrue?: boolean, configId?: number) {
    if (configId) {
      _.forEach(this.timeOutConfig, (config) => {
        if (config.id == configId) {
          this.redirectTime = config.timeOutTimeInSec;
        }
      })
    }
    else {
      this.redirectTime = Constants.CurrentConfigInformations('timeToRedirectUserOnTimeoutInSeconds');
    }
    if (this.isMasterMockTrue || isMockTrue) {
      return this.http.get(`assets/mockJSON/get/${mockFileName}.json`);
    } else {
      if(this.redirectTime)
        this.countDelayedResponse(0);
      return this.getOptions(RequestMethod.Get, options)
        // .map((rOptions: RequestOptions) => rOptions)
        .map((rOptions: RequestOptions) => {
          // console.log('ROLE URL >>', this.API_URL + url, ' ', rOptions); 
          return rOptions;
        })
        .mergeMap((rOptions: RequestOptions) => this.http.request(`${this.API_URL}${url}`, rOptions).do(
          data => {
            if (this.timerArr.length) {
              this.clearAllInterval();
            }
          }
        )
        );
    }
  }

  /**
  @options: interface RequestOptionsArgs {
    url : string
    method : string|RequestMethod
    search : string|URLSearchParams
    headers : Headers
    body : any
    withCredentials : boolean
    responseType : ResponseContentType
  }
  */

  protected postApi(url: string, options: RequestOptionsArgs, mockFileName: string, isMockTrue: boolean = false, configId?: number): Observable<any> {
    if (configId) {
      _.forEach(this.timeOutConfig, (config) => {
        if (config.id == configId) {
          this.redirectTime = config.timeOutTimeInSec;
        }
      })
    }
    else {
      this.redirectTime = Constants.CurrentConfigInformations('timeToRedirectUserOnTimeoutInSeconds');
    }
    if (this.isMasterMockTrue || isMockTrue) {
      return this.http.get(`assets/mockJSON/post/${mockFileName}.json`);
    } else {
      if(this.redirectTime)
        this.countDelayedResponse(0);
      return this.getOptions(RequestMethod.Post, options)
        //.map((rOptions: RequestOptions) => { console.log('LOGIN URL >>' + this.API_URL + url + ' ' + JSON.stringify(rOptions)); return rOptions; })
        .map((rOptions: RequestOptions) => {  return rOptions; }) //console.log('LOGIN URL >>' + this.API_URL + url + ' ' + rOptions);
        .mergeMap((rOptions: RequestOptions) => this.http.request(`${this.API_URL}${url}`, rOptions).do(
          data => {
            if (this.timerArr.length) {
              this.clearAllInterval();
            }

          }
        )
        );
    }

  }

  /**
   @options: interface RequestOptionsArgs {
    url : string
    method : string|RequestMethod
    search : string|URLSearchParams
    headers : Headers
    body : any
    withCredentials : boolean
    responseType : ResponseContentType
    }
   */
  protected putApi(url: string, options: RequestOptionsArgs, mockFileName: string, isMockTrue: boolean = false) {
     
    if (this.isMasterMockTrue || isMockTrue) {
      return this.http.get(`assets/mockJSON/put/${mockFileName}.json`);
    } else {
      if(this.redirectTime)
        this.countDelayedResponse(0);
      return this.getOptions(RequestMethod.Put, options)
        .map((rOptions: RequestOptions) => rOptions)
        .mergeMap((rOptions: RequestOptions) => this.http.request(`${this.API_URL}${url}`, rOptions).do(
          data => {
            if (this.timerArr.length) {
              this.clearAllInterval();
            }
          }
        )
        );
    }

  }

  /**
   @options: interface RequestOptionsArgs {
    url : string
    method : string|RequestMethod
    search : string|URLSearchParams
    headers : Headers
    body : any
    withCredentials : boolean
    responseType : ResponseContentType
    }
   */
  protected deleteApi(url: string, options: RequestOptionsArgs, mockFileName: string, isMockTrue: boolean = false) {
    // this.countDelayedResponse(0);
    if (this.isMasterMockTrue || isMockTrue) {
      return this.http.get(`assets/mockJSON/delete/${mockFileName}.json`);
    } else {
      return this.getOptions(RequestMethod.Delete, options)
        .map((rOptions: RequestOptions) => rOptions)
        .mergeMap((rOptions: RequestOptions) => this.http.request(`${this.API_URL}${url}`, rOptions).do(
          data => {
            if (this.timerArr.length) {
              this.clearAllInterval();
            }
          }
        )
        )
    }
  }

  protected getOptions(method: RequestMethod, requestOptionsArgs: RequestOptionsArgs): Observable<RequestOptions> {
    return Observable.create(observer => {
      let token = Constants.userAuthorisedToken();
      let customerId = Constants.CurrentCustomerInfomations("customerId");
      let head = { 'Content-Type': 'application/json' };
      head['X-Request-Id'] = this.create_UUID();
      if (token) {
        head['Authorization'] = `Bearer ${token}`;

      }
      if (customerId) {
        head['customerId'] = customerId;
      }
      //console.log("Abhik head",head)
      let headers = new Headers(head);
      var options = new RequestOptions({ headers: headers });
      if (requestOptionsArgs) {
        options = options.merge({ method: method });
      }
      if (requestOptionsArgs) {
        options = options.merge(requestOptionsArgs);
      }
      observer.next(options);    // pass the value that catch from subscribe()
      observer.complete();
    });
  }

  protected create_UUID(){
      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
      });
      //console.log("abhik uuid",uuid)
      return uuid;
  }

  protected handleError(error: Response | any) {
    let body: any = {};
    this.response = error.json() || "";
    if (error instanceof Response) {
      if (this.response) {
        body = this.response;
        if (error.status == 200) {
          console.log("200: ", error.json());
        }
        if (error.status == 400) {
          console.log("400: ", error.json());
        }
        if (error.status == 401) {
          console.log("Bkwas...");
        }
      } else {
        body = {
          "code": 0,
          "name": "",
          "message": "Bad request, Server response is string.",
          "result": null
        }
      }
    } else {
      body = {
        "code": 0,
        "name": "",
        "message": error.message ? error.message : error.toString(),
        "result": null
      }
    }
    return Observable.throw(body);
  }

  protected errorHandler(error: Response | any): any {
    if (this.timerArr.length) {
      this.clearAllInterval();
    }
    let body: any = {};
    if (error instanceof Error) {
      body = {
        "name": error.name,
        "title": error.name,
        "errorObj": error,
        "message": "Opps, there is some problem. Please try after some time."
      }
    }
    else if (error instanceof ErrorObservable && error.error instanceof CError) {
      body = error.error
    }
    else if (error instanceof Response) {
      this.response = error.json() || "";
      if (this.response) {
        if (error.status === 400) {
          body = {
            "code": 0,
            "name": "400",
            "title": this.response["name"],
            "message": this.response["message"],
            "result": this.response["result"]
          };
        }
        if (error.status === 401) {
          body = {
            "code": 0,
            "name": "401",
            "title": this.response["name"],
            "message": this.response["message"]
          }
          this._err.expiredSession(this.response);
        }
        if (error.status === 403) {
          if (this.response["code"] === 1007) {
            Constants.Var.isRequiredRefresh = true;
          }
          else {
            body = {
              "code": 0,
              "name": "403",
              "title": this.response["name"],
              "message": this.response["message"]
            }
            this._err.toasterPop(this.response["name"], this.response["message"]);
          }
        }
        if (error.status === 404) {
          body = {
            "code": this.response["code"],
            "name": "404",
            //"title": "Not Found",
            //"message": "The request url was not found on this server."
            "title": this.response["name"],
            "message": this.response["message"]
          }
        }
        if (error.status === 500) {
          body = {
            "code": 0,
            "name": "500",
            "title": "Server error",
            "message": "There is a problem with the resource you are looking for, and it cannot be display."
          }
          this._err.toasterPop(body["title"], body["message"]);
        }
      } else {
        body = {
          "code": 0,
          "name": "ResponseError",
          "title": "Server Response",
          "message": "Bad request, Server response is string."
        }
        this._err.toasterPop(body["title"], body["message"]);
      }
    } else {
      body = {
        "code": 0,
        "name": "CustomError",
        "title": "Error",
        "message": error.message ? error.message : error.toString()
      }
    }
    return Observable.throw(new CError(body));
  }

  // static Error Class.
  static sDefaultCError(): CError {
    return new CError();
  }

  public countDelayedResponse(interval): void {
    this.counter++;
    //console.log('interval==>', interval)
    this.timerArr[this.counter] = setInterval(() => {
      if (interval >= this.redirectTime) {
        if (this.timerArr.length) {
          this.clearAllInterval();
        }
        this.router.navigate(['pages/time-out']);
      }
      interval++;
    }, 1000, interval);

  }

  public clearAllInterval() {
    _.forEach(this.timerArr, (clear, index) => {
      if (clear != null || clear != undefined) {
        clearInterval(this.timerArr[index]);
      }
    })

    this.counter = 0;
    this.timerArr = [];
  }

  protected fileDownloadApi(url: string, options: RequestOptionsArgs, mockFileName: string, isMockTrue: boolean = false) {
    // this.countDelayedResponse(0);
    // console.log('CALL > HttpService.getList()', `${this.API_URL}${url}`, options);
    if (this.isMasterMockTrue || isMockTrue) {
      return this.http.get(`assets/mockJSON/get/${mockFileName}.json`);
    } else {
      return this.getOptions(RequestMethod.Get, options)
        // .map((rOptions: RequestOptions) => rOptions)
        .map((rOptions: RequestOptions) => {
          // console.log('ROLE URL >>', this.API_URL + url, ' ', rOptions); 
          return rOptions;
        })
        .mergeMap((rOptions: RequestOptions) => this.http.request(`${url}`, rOptions).do(
          data => {
            if (this.timerArr.length) {
              this.clearAllInterval();
            }
          }
        )
        );
    }
  }

}

// Class Error
export class CError {
  code: number;
  name: string;
  title: string;
  message: string;
  result: any;
  formFields: Array<string> = [];

  constructor(err?: any) {
    if (err instanceof CError) {
      Object.assign(this, err);
    }
    else if (typeof err == 'object') {
      if (err.code != null) this.code = err.code;
      if (err.name != null) this.name = err.name;
      if (err.title != null) this.title = err.title;
      if (err.message != null) this.message = err.message;
      if (err.result != null) this.result = err.result;
    }
  }

  // Filter messages that belong to form-field
  formFieldErrors(fields?: Array<string>): Array<any> {
    return (this.result && this.result.length)
      ? this.result.filter(item => this.formFields.indexOf(item.field) > -1)
      : [];
  }
  // Filter messages that does not belong to form-field
  otherErrors(): Array<any> {
    return (this.result && this.result.length)
      ? this.result.filter(item => !(this.formFields.indexOf(item.field) > -1))
      : [];
  }


}


// WEBPACK FOOTER //
// ./src/app/services/http.service.ts